import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Transition } from 'react-transition-group';
import { FormattedMessage } from 'react-intl';

import Container from '../../Container';
import Heading from '../../Heading';
import Sauce from './Sauce';

import Overlay from './Overlay';

import styles from './DesktopView.styl';

const cx = classNames.bind(styles);

const duration = 350;

const defaultStyle = {
  transform: 'translateY(100%)',
  transition: `transform ${duration}ms`,
};

const transitionStyles = {
  entering: {
    transform: 'translateY(100%)',
  },
  entered: {
    transform: 'translateY(0%)',
  },
};

export default class DesktopView extends PureComponent {
  render() {
    const { className, list, panelOpened, addFreeSauce, avaivableCount } = this.props;

    return (
      <div className={cx('FreeSaucesPanel', className)}>
        <Overlay isOpen={panelOpened} onClick={this.props.hideFreeSaucesPanel} />
        <Transition in={panelOpened} timeout={duration} mountOnEnter unmountOnExit>
          {state => (
            <div
              className={cx('FreeSaucesPanel__panel', className)}
              style={{
                ...defaultStyle,
                ...transitionStyles[state],
              }}
            >
              <Container>
                <Heading className={cx('FreeSaucesPanel__title')} level={3} tagName="div">
                  <FormattedMessage
                    id="freeSauces.panel.title"
                    values={{ count: avaivableCount }}
                  />
                </Heading>
                <div className={cx('FreeSaucesPanel__list-wrapper')}>
                  <div className={cx('FreeSaucesPanel__list')}>
                    {list.map(sauce => (
                      <Sauce
                        key={sauce.alias}
                        className={cx('FreeSaucesPanel__item')}
                        gift
                        addToCart={addFreeSauce}
                        {...sauce}
                      />
                    ))}
                  </div>
                </div>
              </Container>
            </div>
          )}
        </Transition>
      </div>
    );
  }
}

DesktopView.defaultProps = {
  className: '',
};

DesktopView.propTypes = {
  className: PropTypes.string,
  list: PropTypes.array.isRequired,
  panelOpened: PropTypes.bool.isRequired,
  avaivableCount: PropTypes.number.isRequired,
  addFreeSauce: PropTypes.func.isRequired,
  hideFreeSaucesPanel: PropTypes.func.isRequired,
};
